import { useCallback } from 'react'
import { UseFormMethods } from 'react-hook-form'
import { Input } from 'antd'
import { FormItem } from 'admin/lib/Forms'
import { SiteAddressSearchModalLink } from './SiteAddressSearchModalLink'

export const SiteAddressInput = ({
  form,
  label,
  currentValue,
  addressPath,
  latPath,
  lonPath,
  checkForPopulatedAddress,
  projectCountry
}: {
  form: UseFormMethods
  label: string
  currentValue: string
  addressPath: string
  latPath: string
  lonPath: string
  checkForPopulatedAddress: () => void
  projectCountry: string
}) => {
  const checkFieldIsDirtyByPath = useCallback(
    // dirtyFields is object, e.g. { parent: { parentProp: true, child: { childProp: true } }
    (path: string) => {
      return (
        path
          .split('.')
          .reduce(
            (currentObj, pathPart) =>
              currentObj ? currentObj[pathPart] : undefined,
            form.formState.dirtyFields as
              | Record<string, any>
              | boolean
              | undefined
          ) === true
      )
    },
    [form.formState.dirtyFields]
  )

  checkForPopulatedAddress()

  return (
    <FormItem
      label={label}
      name={addressPath}
      id={`dataAddressKnown`}
      style={{ marginTop: '8px' }}
      defaultValue={currentValue}
      contextLink={
        <SiteAddressSearchModalLink
          currentValue={currentValue}
          projectCountry={projectCountry}
          getGivenIsDirty={() => checkFieldIsDirtyByPath(addressPath)}
          onSubmit={({ known, coordinates }) => {
            form.setValue(addressPath, known, {
              shouldValidate: true,
              shouldDirty: true
            })
            form.setValue(latPath, coordinates.lat, {
              shouldValidate: true,
              shouldDirty: true
            })
            form.setValue(lonPath, coordinates.lon, {
              shouldValidate: true,
              shouldDirty: true
            })
          }}
        />
      }
    >
      <Input.TextArea autoSize rows={1} disabled />
    </FormItem>
  )
}
